module.exports = __webpack_public_path__ + "img/slide-3.bff78bf2.jpg";